import { render, staticRenderFns } from "./PrincipalCliente.vue?vue&type=template&id=0857abff&"
import script from "./PrincipalCliente.vue?vue&type=script&lang=js&"
export * from "./PrincipalCliente.vue?vue&type=script&lang=js&"
import style0 from "./PrincipalCliente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports